import { Modal } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import { Heading } from "@chakra-ui/react";
import { ContentItem } from "./components/ContentItem";
import { formatMoney } from "infra/helpers/number";
import ListaArquivos from "components/ListaArquivos";
import { useLoading } from "components/GlobalLoading";
import moment from "moment";
import { useFindTransferenciaConta } from "core/features/conta/hooks";

interface ModalTransferenciaEntreContasProps {
  onClose: () => void;
  openModal: boolean;
  transferenciaId?: string;
}

function ModalTransferenciaEntreContas({
  transferenciaId,
  onClose,
  openModal,
}: ModalTransferenciaEntreContasProps) {
  const { data, isLoading } = useFindTransferenciaConta(transferenciaId);
  useLoading(isLoading);
  return (
    <>
      <Modal
        centered
        destroyOnClose
        width="1100px"
        visible={openModal}
        onCancel={onClose}
        footer={
          <Flex flex={1} justifyContent="end">
            <OutlineButton onClick={onClose}>Fechar</OutlineButton>
          </Flex>
        }
      >
        <Flex>
          <Heading mb={4} size="md">
            Transferência entre contas
          </Heading>
        </Flex>
        <Flex py="4px" gap={40} mb={4}>
          <ContentItem
            titulo="DATA:"
            descricao={
              data?.data
                ? moment(data?.data, "YYYY-MM").format("MM/YYYY")
                : "--"
            }
          />
          <ContentItem
            titulo="DE:"
            descricao={data?.contaOrigem.nome || "--"}
            banco={`(${data?.contaOrigem.banco}` || "--"}
            conta={`${data?.contaOrigem.conta})` || "(--)"}
          />
          <ContentItem
            titulo="PARA:"
            descricao={data?.contaDestino.nome || "--"}
            banco={`(${data?.contaDestino.banco}` || "--"}
            conta={`${data?.contaDestino.conta})` || "--"}
          />
          <ContentItem
            titulo="VALOR:"
            descricao={data?.valor ? formatMoney(data?.valor) : "--"}
          />
        </Flex>

        {data?.anexos.length ? (
          <Flex>
            <Heading mb={4} size="md">
              Arquivos
            </Heading>
          </Flex>
        ) : null}
        <ListaArquivos
          arquivos={
            data?.anexos.map((anexo) => ({
              referencia: anexo.url,
              nome: anexo.nome,
            })) || []
          }
        />
      </Modal>
    </>
  );
}

export default ModalTransferenciaEntreContas;
